import React from "react";
import { ContextAction, ContextActions, LOCALES, UserModel } from "types";

export const login = (userData: UserModel, dispatch: React.Dispatch<ContextAction>) =>
  dispatch({ type: ContextActions.LOGIN, value: userData });

export const logout = (dispatch: React.Dispatch<ContextAction>) => dispatch({ type: ContextActions.LOGOUT });

export const changeLocale = (locale: LOCALES, dispatch: React.Dispatch<ContextAction>) =>
  dispatch({ type: ContextActions.LOCALE, value: locale });

export const updateLoading = (value: boolean, dispatch: React.Dispatch<ContextAction>) =>
  dispatch({ type: ContextActions.UPDATE_LOADING, value });
